import { useEffect, useRef, useState } from 'react'

export const useTypewriterEffect = (
	prompts: string[] = [],
	options: {
		typingSpeed?: number
		deletingSpeed?: number
		pauseBetweenPrompts?: number
	} = {}
) => {
	const { typingSpeed = 100, deletingSpeed = 50, pauseBetweenPrompts = 2000 } = options

	const [currentText, setCurrentText] = useState('')
	const [currentIndex, setCurrentIndex] = useState(0)
	const [isTyping, setIsTyping] = useState(true)
	const timeoutRef = useRef<NodeJS.Timeout>()

	useEffect(() => {
		if (!prompts.length) return

		const currentPrompt = prompts[currentIndex % prompts.length]

		if (isTyping) {
			// Печатаем текст
			if (currentText.length < currentPrompt.length) {
				timeoutRef.current = setTimeout(() => {
					setCurrentText(currentPrompt.substring(0, currentText.length + 1))
				}, typingSpeed)
			} else {
				// Закончили печатать - ждем и начинаем удалять
				timeoutRef.current = setTimeout(() => {
					setIsTyping(false)
				}, pauseBetweenPrompts)
			}
		} else {
			// Удаляем текст
			if (currentText.length > 0) {
				timeoutRef.current = setTimeout(() => {
					setCurrentText(currentText.substring(0, currentText.length - 1))
				}, deletingSpeed)
			} else {
				// Закончили удалять - переходим к следующему prompt
				setCurrentIndex(prevIndex => (prevIndex + 1) % prompts.length)
				setIsTyping(true)
			}
		}

		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current)
			}
		}
	}, [currentText, currentIndex, isTyping, prompts, typingSpeed, deletingSpeed, pauseBetweenPrompts])

	return currentText
}
